import React, { useState, useEffect } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useDispatch } from "react-redux";
import { putAnthoreTask, putTask } from "../../../Redux/Actions/ActionTask";
import { useSelectorCustom } from "../../General/GeneralComponent/useSelectorCustom";
import SelectWithSearch from "../../General/GeneralComponent/SelectWithSearch";
import { FunctionsLoading } from "../../Main/Statistics/FunctionsLoading";
import GoogleMapReact from "google-map-react";
import { VariableAnthoreTask } from "./VariableAnthoreTask";
import { base_url } from "../../General/Notification";
import axios from "axios"
// Marker Component for the Map
const Marker = () => (
  <div
    style={{
      color: "red",
      fontSize: "24px",
      transform: "translate(-50%, -50%)",
    }}
  >
    📍
  </div>
);

function EditAnthoreTask({ medical_rep_id, t, langmiamed, arr, open, setOpen }) {
  const dispatch = useDispatch();
  const { TGbymedicalRep, loadingTG } = useSelectorCustom();
  const { state, setState, handleChangeTask, setLoad } = VariableAnthoreTask();
  const { LoadTargetByMedicalRepCustom } = FunctionsLoading();
  // Set state based on passed data for editing
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      description: arr.description,
      address: arr.address,
      lat: arr.lat,
      lng: arr.lan,
      report_type_id: arr.report_type_id,
      time: arr.time.replace(/\s*([AaPp][Mm])\s*/, ""),
      date: arr.date,
    }));
  }, [arr]);

  const [reportTypes, setReportTypes] = useState([]); // Store report types

  // Load report types when the component mounts
  useEffect(() => {
    let token = localStorage.getItem("tokenMiamed");
        let langmiamed = localStorage.getItem('langmiamed');
        axios.get(`${base_url}api/report-types`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "lang": langmiamed
            }
        }).then((res) => {
          setReportTypes(res?.data?.data)
            // dispatch(getReportType(res.data.data))
        }).catch((err) => {
        })
  }, []);

  // Handle submit for editing task
  const submit = (e) => {
    e.preventDefault();
    dispatch(
      putAnthoreTask(
        arr.id,
        state.description,
        state.address,
        state.lat,
        state.lng,
        // state.city_id,
        // state.target_group_id,
        state.report_type_id,
        medical_rep_id,
        state.time,
        state.date,
        state.status,
        // state.priority_level,
        arr.work_plan_id,
        setLoad,
        setOpen
      )
    );
  };

  // Handle Map Click - Update lat/lng when map is clicked
  const handleMapClick = ({ lat, lng }) => {
    setState((prevState) => ({
      ...prevState,
      lat,
      lng,
    }));
  };

  return (
    <RModal
    open={open}
    onClose={() => setOpen(false)}
    center
    classNames={{
      modal: "addPop",
    }}
    focusTrapped={false}
  >
    <div className="div_addPop" dir={langmiamed === "ar" ? "rtl" : "ltr"}>
      <h3 className={langmiamed === "ar" ? "textRight" : ""}>
        {t("AnthoreeditTask")}
      </h3>
  
      {/* Address Input */}
      <div className={langmiamed === "ar" ? "textRight" : ""}>
        <span>{t("address")}</span>
      </div>
      <input
        value={state.address || ""}
        type="text"
        onChange={(e) => handleChangeTask(e.target.value, "address")}
      />
  
      {/* Time Input */}
      <div className={langmiamed === "ar" ? "textRight" : ""}>
        <span>{t("time")}</span>
      </div>
      <input
        value={state.time || ""}
        type="time"
        onChange={(e) => handleChangeTask(e.target.value, "time")}
      />
  
  <div className={langmiamed == "ar" ? "textRight" : ""}>
          <span>{t("Report type")}: </span>
        </div>
        <select
          value={
            state.report_type_id === "" ? t("report_type_id") : state.report_type_id
          }
          onChange={(e) => handleChangeTask(e.target.value, "report_type_id")}
        >
          <option disabled="disabled" selected="selected">
            {t("Report type")}
          </option>
          {reportTypes?.map((i)=>{
            return(
              <>
                <option value={i.id}>{t(i.name)}</option>
              </>
            )
          })}
      
        </select>
  
    
  
      {/* Google Map for Location Selection */}
      <div className="col-12">
        <div className={langmiamed === "ar" ? "textRight" : ""}>
          <label>{t("Select Location")}</label>
        </div>
        <div style={{ height: "300px", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyAkCSalRaX8rEi2m2I0E0lhOq94vK3pFzE" }} // Replace with your actual API key
            center={{ lat: state.lat || 0, lng: state.lng || 0 }}
            zoom={10}
            onClick={handleMapClick}
          >
            <Marker lat={state.lat || 0} lng={state.lng || 0} />
          </GoogleMapReact>
        </div>
      
      </div>
  
    {/* Description Textarea */}
    <div className={langmiamed === "ar" ? "textRight" : ""}>
        {t("description")}:{" "}
      </div>
      <textarea
        value={state.description || ""}
        onChange={(e) => handleChangeTask(e.target.value, "description")}
      />
      {/* Submit Button */}
      <button
        disabled={state.Load}
        onClick={submit}
        className={`btn btn-primary w-100 ${state.Load ? "disabled" : ""}`}
      >
        {state.Load ? t("Loading ...") : t("edit")}
      </button>
    </div>
  </RModal>
  
  );
}

export default EditAnthoreTask;
